'use client';

import { Tables } from '@/types_db';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useTrainingsLive } from '@/components/ui/Tones/Status/TrainingsProvider';
import { usePrevious } from '@/utils/hooks/usePrevious';
import GradientSweep from '@/components/ui/GradientSweep/GradientSweep';
type Trainings = Tables<'trainings'>;

const pluralize = (count: number, word: string) => {
  return count === 1 ? word : `${word}s`;
};

interface Props {
  trainings: Partial<Trainings>[];
  isOwner: boolean;
}

const MainStatus = ({ trainings: ssrTrainings, isOwner }: Props) => {
  const [suprise, setSuprise] = useState(false);
  const router = useRouter();

  const liveTrainings = useTrainingsLive();
  const trainings = liveTrainings.length >= ssrTrainings.length ? liveTrainings : ssrTrainings;

  const trainingCount = trainings?.length;
  const successCount = trainings?.filter((training) => training.is_success)?.length;
  const prevSuccessCount = usePrevious(successCount);

  useEffect(() => {
    if (prevSuccessCount === undefined || prevSuccessCount === null) return;
    if (successCount > prevSuccessCount) setSuprise(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successCount, prevSuccessCount]);

  const activeTrainingCount = trainings?.filter(
    (training) => !training.is_success && !training.is_error
  ).length;
  const isTraining = activeTrainingCount > 0;
  const errorTrainingCount = trainings?.filter((training) => training.is_error).length;
  const isError = errorTrainingCount > 0;

  const prevIsTraining = usePrevious(isTraining);
  const prevIsError = usePrevious(isError);

  useEffect(() => {
    if (prevIsError === undefined || prevIsError === null) return;
    if (isError === true && prevIsError === false) router.refresh();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, prevIsError]);

  if (successCount === trainingCount) return;

  return (
    <>
      {suprise && (
        <GradientSweep
          onFinish={() => {
            router.refresh();
            setSuprise(false);
          }}
        />
      )}
      {/* {
        isOwner && isTraining && (
          <div className={'flex flex-col'}>
            <p>{activeTrainingCount} {pluralize(activeTrainingCount, 'model')} in progress</p>
          </div>
        )
      }
      {
        isOwner && isError && (
          <div className={'flex flex-col'}>
            <p>{errorTrainingCount} {pluralize(errorTrainingCount, 'model')} with {pluralize(errorTrainingCount, 'error')}</p>
          </div>
        )
      } */}
    </>
  );
};

export default MainStatus;
